import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import PatientState, { IPatient, PatientList, PatientTypeList, IPatientType } from './states'
import _ from 'lodash'
import axios from 'axios'

const completePathFn = process.env.VUE_APP_BASEURL
const mutations: MutationTree<PatientState> = {
  [mutationType.GET_LISTS](
    state: PatientState,
    data: PatientList,
  ): void {
    state.list = data
  },
  [mutationType.GET_BY_ID](
    state: PatientState,
    data: IPatient,
  ): void {
    state.patient = data
  },
  [mutationType.GET_TYPE_LISTS](
    state: PatientState,
    data: PatientTypeList,
  ): void {
    state.typeList = data
  },
  [mutationType.GET_TYPE_BY_ID](
    state: PatientState,
    data: IPatientType,
  ): void {
    state.typeById = data
  },
}

export default mutations
